'use strict';

const Dictionary = require('./Dictionary');

class Lookup extends Dictionary {
    constructor() {
        super();
    }
}

module.exports = Lookup;